/**
 * Dateから指定の形式で日時を取得
 * @param {Date} d
 * @returns {string}
 */
export function toTime(d = new Date) {
  const date = new Date(d.getTime());

  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  return `${hour}時${minute}分${second}秒`;
}
